<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="employees">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->

          <!-- ADD NEW -->
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Hire a new person</span>
          </div>
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-warning border border-solid border-warning"
            @click="displayInactiveEmployee">
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-warning">{{ buttonName }}</span>
          </div>
          <!-- PUSH vers l'app de pointage XYLO-ATTENDANCE (admin + moderator) -->
          <div
            v-if="canPushToAttendance"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-success border border-solid border-success"
            :class="{ 'opacity-50 pointer-events-none': pushingToAttendance }"
            @click="pushToAttendance">
            <feather-icon icon="UploadCloudIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-success">{{ pushingToAttendance ? 'Pushing…' : 'Push to Attendance' }}</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ employees.length - currentPage
      * itemsPerPage > 0 ? currentPage * itemsPerPage : employees.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="category">Name</vs-th>
        <vs-th sort-key="name">Job Title</vs-th>
        <vs-th sort-key="name">SAGA Code</vs-th>
        <vs-th sort-key="contract">Contract name</vs-th>
        <vs-th sort-key="start">Contract start date</vs-th>
        <vs-th sort-key="stop">Contract stop date</vs-th>
        <vs-th sort-key="pin">PIN</vs-th>
        <vs-th sort-key="active">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="font-medium truncate">{{ tr.people }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.jobtitle }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.sagacode }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.contractname }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.datestart }}</p>
            </vs-td>
            <vs-td>
              <p v-if="tr.datestop">{{ tr.datestop }}</p>
              <p v-else>Permanent contract</p>
            </vs-td>

            <vs-td>
              <p v-if="isadmin">{{ tr.pin }}</p>
              <p v-else>Hidden</p>
            </vs-td>
            <vs-td>
              <vs-chip :color="getActiveColors(tr.isactive)" v-if="tr.isactive >= 0">Active</vs-chip>
              <vs-chip :color="getActiveColors(tr.isactive)" v-else>Inactive</vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)" />&nbsp;&nbsp;&nbsp;
                <!--
              <feather-icon icon="ClockIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="ViewEmployee(tr.idperson)" />&nbsp;&nbsp;&nbsp;-->
              <feather-icon icon="UserIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="ViewPerson(tr.idperson)" />
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import moduleDataListEmployee from '@/store/employee/moduleDataList.js'

export default {
  components: {
    DataViewSidebar
  },
  data() {
    return {
      displayinactive: false,
      isadmin: false,
      canPushToAttendance: false,
      pushingToAttendance: false,
      selected: [],
      itemsPerPage: 1000,
      isMounted: false,
      buttonName: 'Display Inactive',
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    employees() {
      if (this.displayinactive) return this.$store.state.dataListEmployee.employees
      else return this.$store.state.dataListEmployee.employees.filter(employee => employee.isactive >= 0);
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.employees.length
    }
  },
  methods: {
    displayInactiveEmployee() {
      if (this.buttonName.includes("Display Inactive")) {
        this.buttonName = 'Display Only Active'
        this.displayinactive = true;
      }
      else
      {
        this.buttonName = 'Display Inactive'
        this.displayinactive = false;
      }
    },
    ViewEmployee(id) {
      window.location.replace("/web/employees/report/" + id);
    },
    ViewPerson(id) {
      window.location.replace("/web/person/" + id);
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    pushToAttendance() {
      if (this.pushingToAttendance) return
      this.pushingToAttendance = true
      this.$vs.loading()
      this.$store.dispatch('dataListEmployee/pushToAttendance')
        .then((response) => {
          const r = response.data || {}
          const skipped = r.skipped || []
          this.$vs.notify({
            title: 'Pointaj synchronisé',
            text: `${r.created || 0} créé(s), ${r.updated || 0} mis à jour, ${skipped.length} ignoré(s) sur ${r.total || 0}.`,
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: skipped.length ? 'warning' : 'success',
            position: 'bottom-right',
            time: 8000,
          })
          if (skipped.length) {
            const sample = skipped.slice(0, 10)
              .map(s => `#${s.erpId} (${s.reason})`).join(', ')
            this.$vs.notify({
              title: `${skipped.length} employé(s) avec PIN non poussé`,
              text: `PIN invalide (≠ 4 chiffres) ou en double : ${sample}${skipped.length > 10 ? '…' : ''}`,
              iconPack: 'feather',
              icon: 'icon-alert-triangle',
              color: 'warning',
              position: 'bottom-right',
              time: 12000,
            })
          }
        })
        .catch((error) => {
          const msg = (error.response && error.response.data && error.response.data.message) || error.message
          this.$vs.notify({
            title: 'Échec du push vers Pointaj',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: 'bottom-right',
            time: 10000,
          })
        })
        .finally(() => {
          this.pushingToAttendance = false
          this.$vs.loading.close()
        })
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getActiveColors(status) {
      if (status >= 0) return 'primary'
      if (status < 0) return 'danger'
      return 'black'
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    }
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
    const roles = localStorage.getItem("login-roles").toLowerCase()
    if (roles.includes("admin")) this.isadmin = true
    // Push to Attendance : accessible aux admins ET aux modérateurs (ex. Dana).
    if (roles.includes("admin") || roles.includes("moderator")) this.canPushToAttendance = true
    if (!moduleDataListEmployee.isRegistered) {
      this.$store.registerModule('dataListEmployee', moduleDataListEmployee)
      moduleDataListEmployee.isRegistered = true
    }
    this.$store.dispatch('dataListEmployee/fetchDataListItems')
  },
  mounted() {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
